<template>
  <div class="page">
    <van-nav-bar title="项目价值榜" left-arrow @click-left="$router.back()"/>
    <van-field v-model="period" label="月份" type="month" @change="load"/>
    <section>
      <div v-for="row in rows.slice(0,20)" :key="field(row,'task_id')" class="item"><i>{{ field(row, 'rank') }}</i>
        <div><b>{{ field(row, 'task_title') }}</b><span>{{ field(row, 'participant_count') }} 人 · {{
            field(row, 'delivery_count')
          }} 次交付 · {{ field(row, 'health') }}</span></div>
        <strong>{{ field(row, 'value_score') }}</strong></div>
      <van-empty v-if="!rows.length" description="本月暂无项目交付"/>
    </section>
  </div>
</template>
<script>import api from '@/api/brand';

export default {
  data() {
    return {period: new Date().toISOString().slice(0, 7), rows: []}
  }, created() {
    this.load()
  }, methods: {
    field(r, k) {
      return r[k] !== undefined ? r[k] : r[k.toUpperCase()]
    }, async load() {
      try {
        this.rows = await api.projectRank(this.period)
      } catch (e) {
        this.$toast.fail(e.message)
      }
    }
  }
};</script>
<style lang="less" scoped>
@import "./brand-page.less";

section {
  padding: .04rem 0
}

.item {
  display: grid;
  min-height: 1.28rem;
  padding: .12rem .28rem;
  grid-template-columns:.72rem minmax(0, 1fr) 1rem;
  align-items: center;
  border-bottom: 1px solid #eceef3
}

.item:last-of-type {
  border-bottom: 0
}

.item i {
  width: .46rem;
  height: .46rem;
  border-radius: 50%;
  color: #777b8e;
  background: #f0f1f5;
  font-size: .25rem;
  font-style: normal;
  line-height: .46rem;
  text-align: center
}

.item:nth-child(1) i {
  color: #fff;
  background: #d32f2f
}

.item:nth-child(2) i {
  color: #fff;
  background: #ee8b2d
}

.item:nth-child(3) i {
  color: #fff;
  background: #8c92a3
}

.item b, .item span {
  display: block
}

.item b {
  overflow: hidden;
  color: #34364a;
  font-size: .31rem;
  text-overflow: ellipsis;
  white-space: nowrap
}

.item span {
  margin-top: .08rem;
  color: #9295a7;
  font-size: .25rem;
  line-height: 1.45
}

.item strong {
  text-align: right;
  color: #d32f2f;
  font-size: .34rem
}
</style>



// WEBPACK FOOTER //
// src/views/brand/BrandProjectRank.vue